import { render, staticRenderFns } from "./OperaDetailsAWindow.vue?vue&type=template&id=1d638725&scoped=true&"
import script from "./OperaDetailsAWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDetailsAWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaDetailsAWindow.vue?vue&type=style&index=0&id=1d638725&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d638725",
  null
  
)

export default component.exports